import { render, staticRenderFns } from "./ClientLinkBranchMobile.vue?vue&type=template&id=a6580ca8&scoped=true&"
import script from "./ClientLinkBranchMobile.vue?vue&type=script&lang=js&"
export * from "./ClientLinkBranchMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6580ca8",
  null
  
)

export default component.exports